export default function CombinationsController(
  $translate,
  $scope,
  $rootScope,
  $stateParams,
  $window,
  UtilService,
  areasService,
  objectsService,
  combinationsService,
  NotificationService,
  COMBINATION_OPTIONS,
) {
  var vm = this,
    tempCombinationId = 1;

  vm.merchantId = $stateParams.merchantId;
  vm.isLoading = false;
  vm.areaId = null;
  vm.areas = [];
  vm.objects = [];
  vm.combinations = [];
  vm.tableFields = [];
  vm.tableSelectOptions = [];
  vm.tableSelectionInvalid = false;
  vm.selectAllCombinations = false;
  vm.selectedCombinations = [];
  vm.deleteEnabled = false;

  vm.init = init;
  vm.addCombination = addCombination;
  vm.saveCombinations = saveCombinations;
  vm.deleteCombinations = deleteCombinations;
  vm.removeNewCombination = removeNewCombination;
  vm.loadCombinationsForArea = loadCombinationsForArea;
  vm.updateCombinationsOptions = updateCombinationsOptions;
  vm.updateDeleteEnabled = updateDeleteEnabled;
  vm.updateSelectedCombinations = updateSelectedCombinations;
  vm.updateSelectAllCheckbox = updateSelectAllCheckbox;

  var listener = $scope.$on('merchant.tab.combinations.selected', vm.init);
  $scope.$on('merchant.tab.areas.updated', getAreas);
  $scope.$on('merchant.objects.updated', getObjects);

  function init() {
    listener();
    getAreas();
    initTableFields();
  }

  function getAreas() {
    enableLoading();
    areasService
      .getAreas(vm.merchantId)
      .then(function(res) {
        vm.areas = res.data.areas;
      })
      .then(loadCombinations)
      .catch(function() {
        NotificationService.error('Error getting merchant areas');
      })
      .finally(disableLoading);
  }

  function initTableFields() {
    for (var i = 1; i <= COMBINATION_OPTIONS.MAX_OBJECTS; i++) {
      vm.tableFields.push({
        id: i,
        name: 'Table ' + i,
      });
    }
  }

  function loadCombinations() {
    if (vm.areas.length) {
      loadCombinationsForArea(vm.areas[0].id);
    }
  }

  function loadCombinationsForArea(areaId) {
    enableLoading();
    vm.areaId = areaId;
    combinationsService
      .getCombinations(vm.merchantId, vm.areaId)
      .then(initCombinations)
      .then(getObjects)
      .catch(function() {
        NotificationService.error('Error getting combinations');
      })
      .finally(disableLoading);
  }

  function refreshCombinations() {
    enableLoading();
    combinationsService
      .getCombinations(vm.merchantId, vm.areaId)
      .then(initCombinations)
      .then(initTableSelectOptions)
      .catch(function() {
        NotificationService.error('Error getting combinations');
      })
      .finally(disableLoading);
  }

  function initCombinations(res) {
    if (res.data) {
      vm.combinations = res.data;
      vm.selectedCombinations = [];
      vm.selectAllCombinations = false;
      vm.deleteEnabled = false;
    }
  }

  function getObjects() {
    if (vm.merchantId && vm.areaId) {
      objectsService
        .getObjects(vm.merchantId, vm.areaId)
        .then(function(res) {
          vm.objects = res.data.objects;
        })
        .then(initTableSelectOptions)
        .catch(function() {
          NotificationService.error('Error getting merchant tables');
        });
    }
  }

  function initTableSelectOptions() {
    // remove already chosen values from table dropdown options
    for (var i = 0; i < vm.combinations.length; i++) {
      vm.tableSelectOptions[i] = [];
      for (var j = 0; j < COMBINATION_OPTIONS.MAX_OBJECTS; j++) {
        vm.tableSelectOptions[i][j] = vm.objects.filter(function(object) {
          return vm.combinations[i].merchantObjectIds.slice(0, j).indexOf(object.id) === -1;
        });
      }
    }
  }

  function checkIfTableSelectionInvalid() {
    vm.tableSelectionInvalid = vm.combinations.some(function(combination) {
      return combination.merchantObjectIds.length < 2;
    });
  }

  function updateCombinationsOptions(combinationId) {
    var minCapacity,
      maxCapacity,
      combination = UtilService.findElementById(vm.combinations, combinationId);

    // remove null values from merchantObjectIds (ie. deselected tables)
    combination.merchantObjectIds = combination.merchantObjectIds.filter(function(id) {
      return id !== null;
    });
    // update min/max capacity fields
    minCapacity = 0;
    maxCapacity = 0;
    combination.merchantObjectIds.forEach(function(id) {
      vm.objects.forEach(function(object) {
        if (object.id === id) {
          minCapacity += object.minCapacity;
          maxCapacity += object.maxCapacity;
        }
      });
    });
    combination.minCapacity = minCapacity;
    combination.maxCapacity = maxCapacity;

    initTableSelectOptions();
    checkIfTableSelectionInvalid();
  }

  function deleteCombinations() {
    var selectedCombinationIds = [];
    if (vm.isLoading) {
      return;
    }
    if ($window.confirm('Are you sure you want to delete the selected table combination(s)?')) {
      enableLoading();
      vm.selectedCombinations.forEach(function(val, index) {
        if (val) {
          selectedCombinationIds.push(index);
        }
      });
      combinationsService
        .deleteCombinations(vm.merchantId, vm.areaId, selectedCombinationIds)
        .then(function() {
          NotificationService.success('Table combination deleted');
          $rootScope.$broadcast('merchant.combinations.updated');
        })
        .then(refreshCombinations)
        .catch(function() {
          NotificationService.error('Error deleting table combination');
        })
        .finally(disableLoading);
    }
  }

  function updateDeleteEnabled() {
    vm.deleteEnabled = vm.selectedCombinations.find(function(element) {
      return element;
    });
  }

  function updateSelectAllCheckbox() {
    var allCombinationsSelected = true;
    vm.combinations.forEach(function(combination) {
      if (!vm.selectedCombinations[combination.id]) {
        allCombinationsSelected = false;
      }
    });
    vm.selectAllCombinations = allCombinationsSelected;
  }

  function updateSelectedCombinations() {
    if (vm.selectAllCombinations) {
      vm.combinations.forEach(function(combination) {
        vm.selectedCombinations[combination.id] = true;
      });
    } else {
      vm.selectedCombinations = [];
    }
    updateDeleteEnabled();
  }

  function saveCombinations() {
    var updatedCombinations;
    if (vm.isLoading) {
      return;
    }
    enableLoading();
    updatedCombinations = angular.copy(vm.combinations);
    updatedCombinations = updatedCombinations.map(function(combination) {
      if (combination.isNewCombination) {
        combination.id = null;
        delete combination.isNewCombination;
      }
      return combination;
    });
    combinationsService
      .updateCombinations(vm.merchantId, vm.areaId, updatedCombinations)
      .then(function() {
        NotificationService.success('Combinations successfully updated');
        $rootScope.$broadcast('merchant.combinations.updated');
      })
      .then(refreshCombinations)
      .catch(function(res) {
        var error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors,
          errorMessage = error.message ? $translate.instant(error.message) : 'Error updating combinations';
        NotificationService.error(errorMessage);
      })
      .finally(disableLoading);
  }

  function addCombination() {
    vm.combinations.push({
      isNewCombination: true,
      id: 'tempId' + tempCombinationId++,
      name: '',
      maxCapacity: '',
      minCapacity: '',
      bookingPriority: 1,
      merchantObjectIds: [],
    });
    vm.tableSelectionInvalid = true;
    initTableSelectOptions();
  }

  function removeNewCombination(id) {
    vm.combinations = vm.combinations.filter(function(combination) {
      return combination.id !== id;
    });
    initTableSelectOptions();
    checkIfTableSelectionInvalid();
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/combinations/combinations.controller.js